import { Twitter, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function Footer() {
    const navigate = useNavigate();
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-zinc-950 text-white overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 pt-20 md:pt-28 pb-10">
                {/* Top row */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
                    <div className="md:col-span-5">
                        <div className="inline-flex items-center gap-2 font-display text-2xl font-black tracking-tight mb-5">
                            <span className="h-2.5 w-2.5 rounded-full bg-[#E54D2E]" />
                            Build Bout<span className="text-[#E54D2E]">.</span>
                        </div>
                        <p className="max-w-sm text-white/70 leading-relaxed">
                            A co-working community of builders in Nakuru,
                            Kenya. Community. Accountability. Ship together.
                        </p>
                        <div className="mt-6 inline-flex items-center gap-2 text-sm text-white/60">
                            <MapPin className="h-4 w-4" />
                            Nakuru, Kenya
                        </div>
                    </div>
                    <div className="md:col-span-3">
                        <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-white/50 mb-5">
                            Community
                        </h4>
                        <ul className="space-y-3 text-white/80">
                            <li>
                                <a
                                    href="#pillars"
                                    data-testid="footer-pillars-link"
                                    className="hover:text-[#E54D2E] transition-colors"
                                >
                                    How we work
                                </a>
                            </li>
                            <li>
                                <Link
                                    to="/hackathon"
                                    data-testid="footer-hackathon-link"
                                    className="hover:text-[#E54D2E] transition-colors"
                                >
                                    Agentic Hack: Payments &amp; Robots
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/events"
                                    data-testid="footer-events-link"
                                    className="hover:text-[#E54D2E] transition-colors"
                                >
                                    Events &amp; RSVP
                                </Link>
                            </li>
                            <li>
                                <a
                                    href="#gallery"
                                    data-testid="footer-gallery-link"
                                    className="hover:text-[#E54D2E] transition-colors"
                                >
                                    Gallery
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#faq"
                                    data-testid="footer-faq-link"
                                    className="hover:text-[#E54D2E] transition-colors"
                                >
                                    FAQ
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <h4 className="text-xs font-mono uppercase tracking-[0.2em] text-white/50 mb-5">
                            Get in touch
                        </h4>
                        <div className="flex flex-col gap-3">
                            <a
                                href="https://twitter.com/chepparing"
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-twitter"
                                className="group inline-flex items-center justify-between gap-4 py-3 border-b border-white/10 hover:border-[#E54D2E] transition-colors"
                            >
                                <span className="inline-flex items-center gap-3 text-white/90">
                                    <Twitter className="h-4 w-4" />
                                    @chepparing
                                </span>
                                <ArrowUpRight className="h-4 w-4 text-white/50 group-hover:text-[#E54D2E] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                            </a>
                            <a
                                href="mailto:chidi@cheppar.co.ke"
                                data-testid="footer-email"
                                className="group inline-flex items-center justify-between gap-4 py-3 border-b border-white/10 hover:border-[#E54D2E] transition-colors"
                            >
                                <span className="inline-flex items-center gap-3 text-white/90">
                                    <Mail className="h-4 w-4" />
                                    chidi@cheppar.co.ke
                                </span>
                                <ArrowUpRight className="h-4 w-4 text-white/50 group-hover:text-[#E54D2E] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                            </a>
                            <button
                                type="button"
                                onClick={() => navigate("/hackathon")}
                                data-testid="footer-join-btn"
                                className="mt-3 h-12 inline-flex items-center justify-center gap-2 rounded-full bg-[#E54D2E] text-white text-sm font-medium hover:bg-white hover:text-zinc-950 transition-colors"
                            >
                                Register for Event
                                <ArrowUpRight className="h-4 w-4" />
                            </button>
                        </div>
                    </div>
                </div>

                {/* Massive typographic mark */}
                <div className="relative border-t border-white/10 pt-10">
                    <div
                        aria-hidden
                        className="font-display font-black tracking-[-0.05em] leading-none text-white/[0.06] select-none"
                        style={{ fontSize: "min(22vw, 360px)" }}
                    >
                        BUILD BOUT
                    </div>
                    <div className="mt-4 flex flex-wrap items-center justify-between gap-4 text-xs text-white/50 font-mono uppercase tracking-[0.2em]">
                        <span>
                            © {new Date().getFullYear()} Cheppar · All rights
                            reserved
                        </span>
                        <span className="flex items-center gap-2">
                            <span className="h-1.5 w-1.5 rounded-full bg-[#E54D2E] pulse-dot" />
                            Shipping from Nakuru
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
